import { NgModule } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { UsersComponent } from './users/users.component';
import { CatalogsRoutingModule } from './catalogs-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { VehiclesComponent } from './vehicles/vehicles.component';
import { VehiclesAddComponent } from './vehicles/vehicles-add/vehicles-add.component';
import { UsersAddComponent } from './users/users-add/users-add.component';
import { JustificationsComponent } from './justifications/justifications.component';
import { JustificationsAddComponent } from './justifications/justifications-add/justifications-add.component';
import { CompaniesComponent } from './companies/companies.component';
import { CompaniesAddComponent } from './companies/companies-add/companies-add.component';
import { PlantsComponent } from './plants/plants.component';
import { PlantsAddComponent } from './plants/plants-add/plants-add.component';
import { WarehousesComponent } from './warehouses/warehouses.component';
import { WarehousesAddComponent } from './warehouses/warehouses-add/warehouses-add.component';
import { ProvidersComponent } from './providers/providers.component';
import { ProvidersAddComponent } from './providers/providers-add/providers-add.component';
import { AuthRejectComponent } from './auth-reject/auth-reject.component';
import { AuthRejectAddComponent } from './auth-reject/auth-reject-add/auth-reject-add.component';
import { ShipsComponent } from './ships/ships.component';
import { ShipsAddComponent } from './ships/ships-add/ships-add.component';
import { InventaryComponent } from './inventary/invetnary.component';
import { InventaryAddComponent } from './inventary/inventary-add/inventary-add.component';

@NgModule({
  declarations: [
    UsersComponent,
    UsersAddComponent,
    VehiclesComponent,
    VehiclesAddComponent,
    JustificationsComponent,
    JustificationsAddComponent,
    CompaniesComponent,
    CompaniesAddComponent,
    PlantsComponent,
    PlantsAddComponent,
    WarehousesComponent,
    WarehousesAddComponent,
    ProvidersComponent,
    ProvidersAddComponent,
    AuthRejectComponent,
    AuthRejectAddComponent,
    ShipsComponent,
    ShipsAddComponent,
    InventaryComponent,
    InventaryAddComponent
  ],
  imports: [
    CatalogsRoutingModule,
    TranslateModule,
    SharedModule
  ],
  exports: [UsersComponent, VehiclesComponent, VehiclesAddComponent, UsersAddComponent, JustificationsComponent, JustificationsAddComponent,
  CompaniesComponent, CompaniesAddComponent, PlantsComponent, PlantsAddComponent, WarehousesComponent, WarehousesAddComponent,
  ProvidersComponent, ProvidersAddComponent, AuthRejectComponent, AuthRejectAddComponent, ShipsComponent, ShipsAddComponent, 
  InventaryComponent, InventaryAddComponent]
})
export class CatalogsModule {
  constructor(public translate: TranslateService) {
  }
}
